export class ErrorStringifier {
  static getMessage(ex: any): string {
    ErrorStringifier.normalizeError(ex);

    let message = "";
    if (ex.responseJSON) {
      const err = ex.responseJSON;

      if (err.error) {
        message += err.error;
      }
    }
    return message;
  }

  static getDetails(ex: any): string {
    let message: string = `Zeitpunkt: ${new Date().toLocaleString()}`;

    ErrorStringifier.normalizeError(ex);

    if (ex.status === 403) {
      message += `<p><strong>${ex.status}</strong> - Fehlende Berechtigung</p>`;
    }

    if (ex.message) {
      message += "<p>" + ex.message + "</p>";
    }

    if (ex.responseJSON) {
      const err = ex.responseJSON;

      message += "<p>";
      message += "<p>";
      if (err.status) {
        message += `<strong>${err.status}</strong> - `;
      }

      if (err.phrase) {
        message += err.phrase + " ";
      }

      if (err.error) {
        message += `<br /><br />${err.error}`;
      }

      message += "</p>";
    }

    if (ex.status === 0) {
      message += "<p>Keine Verbindung zum Server.</p>";
    }

    return message;
  }

  private static normalizeError(ex: any) {
    if (ex.response && !ex.responseJSON) {
      ex.responseJSON = ErrorStringifier._parseJson(ex.response);
    }

    if (ex.responseText && !ex.responseJSON) {
      ex.responseJSON = ErrorStringifier._parseJson(ex.responseText);
    }
  }

  private static _parseJson(text: string): { error: string; family: string; phrase: string; status: string } {
    try {
      return JSON.parse(text);
    } catch (ex: any) {
      ex.responseJSON = {
        error: "Unknown error",
        family: "Unknown",
        phrase: "Unknown error",
        status: 999,
      };
    }
  }
}
